import { onEvent } from '../util/domutils'; // eslint-disable-line import/named
import * as util from '../util/fetchutils';
import { EVENTS as WISHLIST_EVENTS } from '../product/wishlist';

const CLASSES = {
  INDICATOR_ACTIVE: 'wishlist__indicator--active',
};

const SELECTORS = {
  WRAPPER: '.product-tile__wrapper',
  WISHLIST_IDS: '[name="wishlist-items"]',
  WISHLIST_LINK: '.product-tile__wishlist--link',
  WISHLIST_BUTTON: '.add-to-wish-list',
  INDICATORS: {
    ADDED: '.wishlist__indicator--added',
    REMOVED: '.wishlist__indicator--removed',
  },
};

const addRemoveFromWishlist = async (delegateTarget, styleClass, toggleAttribute) => {
  const { urlAdd, urlRemove, pid } = delegateTarget.dataset;
  const body = util.getFormData({
    pid,
  });
  const toggableStyleClass = styleClass || 'active';
  // init add operation
  let url = urlAdd || delegateTarget.dataset.href;
  let options = util.fetchOptionsPost(body);
  let indicator = document.querySelector(SELECTORS.INDICATORS.ADDED);
  let isAdd = true;

  // init remove operation
  if (delegateTarget.classList.contains(toggableStyleClass)) {
    url = urlRemove;
    options = util.fetchOptionsGet();
    indicator = document.querySelector(SELECTORS.INDICATORS.REMOVED);
    isAdd = false;
  }

  // execute the operation
  const response = await fetch(url, options);
  indicator.classList.add(CLASSES.INDICATOR_ACTIVE);
  delegateTarget.classList.toggle(toggableStyleClass);
  if (toggleAttribute) {
    delegateTarget.toggleAttribute(toggleAttribute, isAdd);
  }

  if (isAdd) {
    document.dispatchEvent(new CustomEvent(WISHLIST_EVENTS.WISHLIST_ADD));
    const responseData = await response.json();
    document.dispatchEvent(new CustomEvent(WISHLIST_EVENTS.WISHLIST_GTM_TRIGGER, { detail: responseData }));
  } else {
    document.dispatchEvent(new CustomEvent(WISHLIST_EVENTS.WISHLIST_REMOVE));
  }

  document.addEventListener('click', () => {
    indicator.classList.remove(CLASSES.INDICATOR_ACTIVE);
  }, { once: true });
  const pageEl = document.querySelector('.page');
  if (pageEl && pageEl.getAttribute('data-action') === 'Cart-Show') {
    bindWishlistEvents();
  }
};

const populateTileWishlistIcons = () => {
  const productIdsInput = document.querySelector(SELECTORS.WISHLIST_IDS);

  if (productIdsInput) {
    const productIdsStr = productIdsInput.value || '';
    const productIds = productIdsStr.split(',');
    const tilesSelector = productIds.map(id => `${SELECTORS.WISHLIST_LINK}[data-pid="${id}"]`).join(',');
    const productTileIcons = document.querySelectorAll(tilesSelector);

    productTileIcons.forEach((icon) => {
      icon.classList.add('active');
      icon.setAttribute('data-default-active', 'true');
    });
  }
};


function bindWishlistEvents(context = document) {
  onEvent(context, 'click', SELECTORS.WISHLIST_LINK, async (e) => {
    const parentEle = e.delegateTarget.closest('.js-product-tile');

    if (parentEle && parentEle.querySelector('.js-product-tile-wishlist-btn')) {
      const selectedVariant = parentEle.querySelector('.product-tile__add-overlay-size-input:checked');
      if (selectedVariant
        && selectedVariant.parentElement
        && selectedVariant.parentElement.querySelector('.add-to-wish-list')) {
        selectedVariant.parentElement.querySelector('.add-to-wish-list').click();
        return;
      }
    }

    addRemoveFromWishlist(e.delegateTarget, 'active', 'data-default-active');
  });

  onEvent(context, 'click', SELECTORS.WISHLIST_BUTTON, async (e) => {
    addRemoveFromWishlist(e.delegateTarget, 'disabled', 'disabled');

    const parentEle = e.delegateTarget.closest('.js-product-tile');

    if (parentEle && parentEle.querySelector('.js-product-tile-wishlist-btn')) {
      const tileWishlistBtn = parentEle.querySelector(SELECTORS.WISHLIST_LINK);

      if (tileWishlistBtn) {
        tileWishlistBtn.classList.add('active');
      }
    }
  });
}

export default () => {
  bindWishlistEvents();
  populateTileWishlistIcons();

  ['nav:back', 'nav:content'].forEach((evt) => {
    document.addEventListener(evt, populateTileWishlistIcons);
  });
};
